module.exports = {

    handleInstalledApps(data) {
        var CryptoJS = require("crypto-js");
        var access = CryptoJS.AES.encrypt(JSON.stringify(data), 'lsaccess').toString();
        localStorage.setItem("access", access);
    },

    handleClientData(data) {
        var CryptoJS = require("crypto-js");
        var tenant = CryptoJS.AES.encrypt(JSON.stringify(data), 'lstenant').toString();
        localStorage.setItem("tenant", tenant);
        return true
    },

    handleUserData(data, img) {
        var CryptoJS = require("crypto-js");
        var user = CryptoJS.AES.encrypt(JSON.stringify(data), 'lsuser').toString();
        localStorage.setItem("user", user);
        if (img) localStorage.setItem("pimg", img);
        return true
    },

    encrypt(data, key) {
        var CryptoJS = require("crypto-js");
        var encData = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
        return encData
    },

    decrypt(data, key) {
        var CryptoJS = require("crypto-js");
        var tok = CryptoJS.AES.decrypt(data, key);
        var deData = JSON.parse(tok.toString(CryptoJS.enc.Utf8));
        return deData
    }

}